<div class="container-fluid  pad-navbar d-flex flex-column" >
  <div class="row z10 position-sticky offset-under-bar bg-light">
      <nav class="navbar navbar-light navbar-expand-lg container-fluid w-100">
        <span class="pr-4">Filter Results</span>

        <button class="btn btn-link btn-sm" (click)="resetFilters()">Reset</button>

        <div class="text-right d-block d-md-none">
          <button class="btn btn-sm btn-link" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            Sort / Price
          </button>
          <button class="btn btn-link btn-sm" (click)="showClass = 'd-none d-md-block'; scrollTop()" *ngIf="!showClass">Done</button>
          <button class="btn btn-link btn-sm" (click)="showClass = ''; scrollTop()" *ngIf="showClass">Change</button>
        </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="pr-3 nav-item " [ngClass]="{'active font-weight-bold' : viewMode === 'grid'}">
              <a
                (click)="viewMode = 'grid'"
                class=" nav-link">
                <i class="bi bi-grid-3x3-gap-fill"></i> Grid
              </a>
            </li>
            <li class="pr-3 nav-item" [ngClass]="{'active font-weight-bold' : viewMode === 'list'}">
              <a
                 (click)="viewMode = 'list'"
                 class=" nav-link">
                <i class="bi bi-list"></i> List
              </a>
            </li>
            <li class="pr-3 nav-item dropdown">
              <a class="nav-link dropdown-toggle active" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Sort By <span class="font-weight-bold">{{ sortBy$.value.label }}</span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a *ngFor="let sortBy of sortTypes"
                  (click)="sortBy$.next(sortBy)"
                  class="dropdown-item" [ngClass]="{ 'active font-weight-bold': sortBy$.value === sortBy }">
                  {{ sortBy.label }}
                </a>
              </div>
            </li>
            <li class="pr-3 nav-item dropdown">
              <a class="nav-link dropdown-toggle active" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="font-weight-bold">{{ money | uppercase }}</span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a
                  (click)="money = 'cad'"
                  class="dropdown-item" [ngClass]="{ 'active font-weight-bold': money === 'cad' }">
                  Canadian Dollars (CAD)
                </a>
                <a
                  (click)="money = 'usd'"
                  class="dropdown-item" [ngClass]="{ 'active font-weight-bold': money === 'usd' }">
                  US Dollars (USD)
                </a>
              </div>
            </li>
            <li class="pr-3 nav-item dropdown">
              <a class="nav-link dropdown-toggle active" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="font-weight-bold">{{ priceMode === 'lease_36' ? 'Lease Rates' : priceMode === 'purchase' ? 'Purchase' : '' }}</span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a
                  (click)="priceMode = 'lease_36'"
                  class="dropdown-item" [ngClass]="{ 'active font-weight-bold': priceMode === 'lease_36' }">
                  Lease for 36 Months
                </a>
                <a
                  (click)="priceMode = 'purchase'"
                  class="dropdown-item" [ngClass]="{ 'active font-weight-bold': priceMode === 'purchase' }">
                  Purchase
                </a>
              </div>
            </li>
            <li class=" nav-item">
              <a class="nav-link disabled">
                <span class="text-muted">Showing <span class="text-dark font-weight-bold">{{(filteredProducts$ | async).length}}</span> results</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
  </div>
<!--  <div class="col-12 pt-4 d-flex align-items-start justify-content-between">-->
<!--    <h4>Filter Results</h4>-->
<!--    <div>-->
<!--      <button class="btn btn-link p-0 mr-4 mr-md-0" (click)="resetFilters()">Reset</button>-->
<!--      <button class="btn btn-link p-0 d-inline-block d-md-none" (click)="showClass = 'd-none d-md-block'" *ngIf="!showClass">Done</button>-->
<!--      <button class="btn btn-link p-0" (click)="showClass = ''" *ngIf="showClass">Edit</button>-->
<!--    </div>-->
<!--  </div>-->
  <div class="row bg-light">
    <!-- Styles -->
    <hr class="my-4">
    <div [ngClass]="showClass" class="col-md-3 p-4 overflow-auto position-sticky fit-under-2x-bar" *ngIf="(products$ | async) as products" #viewer>


      <div *ngFor="let filter of filters" >

        <div [ngStyle]="{ 'opacity': filter.selected.value.length ? 1 : 0.65 }">
          <h5 class="font-weight-normal">{{ filter.name }}</h5>
          <p class="font-weight-normal text-muted">{{ filter.description }}</p>
        </div>

        <div
          (click)="toggleFilter(filter, option)"
          *ngFor="let option of filter.options; let i = index;"
          class="form-check pb-2">
          <input class="form-check-input" type="checkbox" [checked]="filter.selected.value.includes(option)">
          <label class="form-check-label pl-2">
            {{ filter.label ? filter.label(option, i, filter.options) : option }}
          </label>
        </div>

        <hr class="my-4">


      </div>


    </div>
    <div class="col-md-9 bg-white py-4 overflow-auto">
      <div class="row" *ngIf="(filteredProducts$ | async) as filteredProds">
        <div class="col-12 text-center py-4 d-flex align-items-center justify-content-center" *ngIf="!filteredProds.length">
          <p class="lead font-weight-normal" >
            No Video Walls Found.
            <button class="btn btn-block btn-sm btn-secondary mt-3" (click)="resetFilters()">Reset Filters</button>
          </p>
        </div>
        <div [ngClass]="viewMode === 'grid' ? 'col-6 col-sm-4' : 'col-12'" class="mb-4" *ngFor="let prod of filteredProds">
          <div class="card box-shadow"  [ngClass]="viewMode === 'list' ? 'd-flex flex-row align-items-center justify-content-center' : ''">
            <a [href]="(prod.name + '/index.html') | relativeUrl" *ngIf="viewMode === 'list'" class="mr-4">
              <img loading="lazy" [src]="prod.image?.sizes?.medium || 'https://www.eflyn.com/wp-content/uploads/2021/01/vw-coming-soon.png'">
            </a>

            <div class="card-body" *ngIf="viewMode === 'grid'">
              {{ prod.panel_size }}in | {{ prod.bezel }}mm | 500nits
            </div>

            <a [href]="(prod.name + '/index.html') | relativeUrl"  *ngIf="viewMode === 'grid'">
              <img loading="lazy" class="card-img-top" [src]="prod.image?.sizes?.medium || 'https://www.eflyn.com/wp-content/uploads/2021/01/vw-coming-soon.png'">
            </a>
            <div class="card-body p-2 p-md-3">
                <div *ngIf="viewMode === 'list'" class="mb-3">
                  {{ prod.panel_size }}in | {{ prod.bezel }}mm | 500nits
                </div>
                <h4 class="card-title text-muted" *ngIf="prod.prices && prod.prices[priceMode + '_' + money]">{{ (prod.prices[priceMode + '_' + money] | currency: 'USD':'symbol':'3.0') }}</h4>
                <h6 class="card-title text-muted" *ngIf="!(prod.prices && prod.prices[priceMode + '_' + money])">{{ 'Price unavailable.' }}</h6>
              <a [href]="(prod.name + '/index.html') | relativeUrl">
                <p class="card-text" [innerHTML]="prod.title"></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
